export const eventHandler = (name, data, isGA=true) => {
  if(typeof (trackAnalyticsEvent) !== undefined){
  trackAnalyticsEvent(name, data, isGA);
  }
}